import { Component } from '@angular/core';
import { I18NService } from '@socrates/socrates-shared';

@Component({
	selector: 'app-guidelines',
	templateUrl: './guidelines.component.html',
	standalone: false,
})
export class GuidelinesComponent {
	readonly expectations = ['engageIdea','beSpecific','beHonest','bePatient','acceptOutcomes'];
	readonly prohibited   = ['badFaith','coordination','deanonymizing','promotion','circumvention','harassment'];

	getMessage(key: string): string {
		return I18NService.getMessage(key);
	}
}
